import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { RegisterDtoExt } from '../account/models';
import type { ResetPasswordDto, SendPasswordResetCodeDto, VerifyPasswordResetTokenInput } from '../../../volo/abp/account/models';
import type { IdentityUserDto } from '../../../volo/abp/identity/models';

@Injectable({
  providedIn: 'root',
})
export class AccountAppServiceExService {
  apiName = 'Default';
  

  deregister = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/account-app-service-ex/deregister',
    },
    { apiName: this.apiName,...config });
  

  register = (input: RegisterDtoExt, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'POST',
      url: '/api/account/register-ex',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  resetPassword = (input: ResetPasswordDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/account-app-service-ex/reset-password',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  sendPasswordResetCode = (input: SendPasswordResetCodeDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/account-app-service-ex/send-password-reset-code',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  verifyPasswordResetToken = (input: VerifyPasswordResetTokenInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/account-app-service-ex/verify-password-reset-token',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
